import { Editor, useEditorState } from "@tiptap/react";
import { useCallback } from "react";

import deepEql from "fast-deep-equal";

import { SidebarMenu } from "utils/ui";

export const SidebarSpacerBlockMenu = ({ editor }: { editor: Editor }) => {
  const { height } = useEditorState({
    editor,
    selector: (ctx) => {
      return {
        height: parseInt(ctx.editor.getAttributes("spacerBlock")?.height || 0),
      };
    },
    equalityFn: deepEql,
  });

  const onWidthChange = useCallback(
    (value: number) => {
      editor.chain().focus(undefined, { scrollIntoView: false }).setSpacerBlockHeight(value).run();
    },
    [editor]
  );

  return (
    <div className="w-full">
      <SidebarMenu.Description>A spacer adds adjustable vertical space between blocks. It prints as empty space.</SidebarMenu.Description>
      <SidebarMenu.Heading title="Height" value={height} />
      <SidebarMenu.SliderInput onChange={onWidthChange} value={height} />
    </div>
  );
};
